var actions = {
	next: "Próximo",
	confirm: "Confirmar",
	"continue": "Continuar"
};
var errors = {
	unknown: "Ocorreu um erro desconhecido",
	contactSupport: "Ocorreu um erro. Entre em contato com o suporte.",
	tryAgain: "Ocorreu um erro. Tente novamente.",
	submit: "Ocorreu um erro em sua submissão."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Entrar com {name}",
	signupWith: "Inscreva-se com {name}"
};
var alreadyHaveAccount = {
	company: "Já possui uma conta da {company}?",
	text: "Já possui uma Streamlabs ID?",
	link: "Entrar"
};
var noAccount = {
	text: "Ainda não tem uma conta?",
	link: "Inscrever-se"
};
var validation = {
	email: {
		invalid: "Insira um endereço de e-mail válido"
	},
	password: {
		required: "A senha é obrigatória",
		min: "A senha deve conter mais de 8 caracteres",
		number: "A senha deve conter um número",
		upper: "A senha deve conter um caractere maiúsculo",
		special: "A senha deve conter um caractere especial"
	},
	username: {
		invalid: "O nome deve conter ao menos 5 caracteres"
	},
	code: {
		minmax: "O código deve ter entre 6 e 10 caracteres"
	}
};
var poweredBy = "Distribuído por <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Empresa não encontrada!",
		desc: "Tente novamente ou fale com o suporte."
	},
	company: {
		logoAlt: "Logotipo {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Código autorização 6 dígitos/código backup 8 dígitos",
	successText: "Sucesso! Redirecionando...",
	remember: "Lembrar deste dispositivo por 30 dias"
};
var createTfa = {
	scan: {
		title: "Habilitar autenticação em dois fatores",
		lead: "Clique/copie ou escaneie o código a seguir em seu aplicativo de autenticação de preferência. Recomendamos aplicativos como <app0 />, <app1 /> ou <app2 /> para resguardar seus códigos.",
		copied: "Copiado!",
		instructions: "Ou insira este código manualmente em seu aplicativo de autenticação.",
		copy: "Copiar código",
		proceed: "Confirmação"
	},
	confirm: {
		title: "Confirmar autenticação de 2 fatores",
		lead: "Envie o código de autenticação de 2 etapas gerado abaixo para confirmar e habilitar a autenticação de 2 etapas.",
		label: "Código de autenticação de 2 etapas (6 dígitos)",
		verify: "Verificar código",
		next: "Sucesso! Próxima etapa"
	},
	save: {
		title: "Salve seus Códigos de Recuperação",
		lead: "Salve seus códigos de recuperação a seguir caso perca acesso à sua autenticação de 2 etapas. Os códigos não estarão mais disponíveis após fechar este modal.",
		label: "Códigos de Recuperação",
		download: "Baixar Códigos de Recuperação",
		copied: "Códigos copiados!",
		finished: "Finalizado"
	}
};
var emailLoginForm = {
	buttonText: "Entrar",
	emailPlaceholder: "E-mail",
	passwordPlaceholder: "Senha"
};
var emailSignupForm = {
	buttonText: "Inscrever-se",
	emailPlaceholder: "Definir e-mail",
	passwordPlaceholder: "Definir senha",
	usernamePlaceholder: "Seu nome",
	ageLabel: "Data de nascimento",
	agePlaceholder: "DD/MM/AAAA",
	agreeText: "Concordo com os <terms>Termos de Serviço</terms> e <privacy>Política de Privacidade</privacy> do Streamlabs.",
	agreeError: "Concorde com os termos e condições Streamlabs"
};
var ageInput = {
	invalidDate: "Digite uma data de nascimento válida",
	futureDate: "A data de nascimento deve estar no passado",
	minDate: "Não são permitidas datas anteriores ao ano {year} ",
	minAge_one: "Você deve ter {years} anos de idade ou mais para usar o Streamlabs",
	minAge_two: "Você deve ter {years} anos de idade ou mais para usar o Streamlabs",
	minAge_other: "Você deve ter {years} anos de idade ou mais para usar o Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mail",
	back: "Voltar a Registrar",
	successText: "Sucesso! Enviamos a você um código de redefinição de senha.",
	buttonText: "Solicitar um e-mail de reset",
	create: {
		successText: "Sucesso! Enviamos um código de verificação para você começar.",
		buttonText: "Solicitar código de verificação"
	},
	errors: {
		notFound: "Nenhuma conta encontrada com este endereço de e-mail"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Esqueceu sua senha?",
	lead: "Caso precise redefinir sua senha, insira seu e-mail abaixo e lhe enviaremos um e-mail para inciar o processo.",
	resetTitle: "Redefinir sua senha",
	resetLead: "Você deve ter recebido um código por e-mail. Complete o formulário para redefinir sua senha.",
	create: {
		title: "Criar sua senha",
		lead: "Parabéns por criar sua ID do Streamlabs! Mais uma etapa e você poderá fazer login em todo o Streamlabs!",
		resetTitle: "Escolher uma senha",
		resetLead: "Você deve ter recebido um código por e-mail. Use-o e preencha o formulário para definir sua senha."
	},
	successText: "Sucesso! Redirecionando...",
	signInTitle: "Já possui uma conta?",
	signInBtn: "Entrar"
};
var checkTfaCard = {
	title: "Verificação de autenticação de dois fatores",
	lead: "Insira o código de autenticação de 2 etapas abaixo para continuar.",
	successText: "Autenticação de 2 etapas concluída!",
	back: "Voltar"
};
var verifyEmailCard = {
	title: "Verificar seu e-mail",
	lead: "Verifique em seu e-mail o código de 8 dígitos do Streamlabs e insira-o abaixo.",
	back: "Voltar",
	successText: "E-mail verificado!"
};
var upgradeCard = {
	confirm: {
		title: "Confirmar conexão com {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"No futuro, você poderá fazer o login no {company} com o e-mail e a senha fornecidos.",
			"Você pode acessar todos os outros produtos Streamlabs com sua ID e conectar outras contas existentes, se tiver alguma.",
			"Sua conta {company} não será impactada por esta mudança."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Alternar conta",
		success: "Conectando..."
	},
	confirmed: {
		title: "Sucesso!",
		subtitle: "Sua Streamlabs ID foi criada e sua conta {company} está conectada.",
		text: "Você pode usar sua Streamlabs ID para todos os produtos Streamlabs. Se você tiver contas existentes, você pode conectá-las a esta ID dentro de cada aplicativo.",
		button: "Fechar"
	},
	error: {
		user: "A identificação do usuário falhou. Tente fazer o login novamente ou entre em contato com o suporte."
	}
};
var confirmCard = {
	confirm: {
		title: "Confirmar conexão com {company}",
		subtitle: "Encontramos uma conta com um e-mail correspondente. Gostaria de vincular esta conta com o Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Você poderá fazer o login no {company} com o e-mail e a senha que você forneceu por meio do Streamlabs ID.",
			"Você pode acessar todos os outros produtos Streamlabs com sua ID e conectar outras contas existentes, se tiver alguma.",
			"A conta da sua empresa não será impactada por esta mudança."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Alternar conta",
		success: "Conectando..."
	},
	confirmed: {
		title: "Sucesso!",
		subtitle: "Sua Streamlabs ID foi criada e sua conta {company} está conectada.",
		text: "Você pode usar sua Streamlabs ID para todos os produtos Streamlabs. Se você tiver contas existentes, você pode conectá-las a esta ID dentro de cada aplicativo.",
		button: "Fechar"
	},
	error: {
		user: "A identificação do usuário falhou. Tente fazer o login novamente ou entre em contato com o suporte."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Sua ID já tem uma conta {company} conectada",
		subtitle: "Gostaria de desvincular a conta conectada e vincular à sua conta Streamlabs atual?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Você poderá fazer o login no Streamlabs com o e-mail e a senha que você forneceu para a Streamlabs ID.",
			"Você pode acessar todos os outros produtos Streamlabs com sua ID e conectar outras contas existentes, se tiver alguma.",
			"Sua conta Streamlabs não será impactada por esta mudança."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Alternar conta",
		success: "Conectando...",
		agreeLabel: "Entendo que ao fazer esta conexão eu perderei acesso à conta {company} existente que está ligada à Streamlabs ID."
	},
	confirmed: {
		title: "Sucesso!",
		subtitle: "Sua Streamlabs ID foi criada e sua conta {company} está conectada.",
		text: "Você pode usar sua Streamlabs ID para todos os produtos Streamlabs. Se você tiver contas existentes, você pode conectá-las a esta ID dentro de cada aplicativo.",
		button: "Fechar"
	},
	error: {
		user: "A identificação do usuário falhou. Tente fazer o login novamente ou entre em contato com o suporte."
	}
};
var loginCard = {
	title: "Entrar",
	lead: "Entrar em <company>{company}</company> com <id>Streamlabs ID</id>",
	accountExists: "Parece que você já possui uma <b>Streamlabs ID</b>. Tente entrar usando seu e-mail.",
	forgotPassword: "Esqueceu a senha?",
	successText: "Sucesso! Redirecionando...",
	signInTitle: "Entrar com uma plataforma"
};
var loginSourcesCard = {
	title: "Entrar",
	lead: "Entrar com e-mail/senha",
	withSlId: "Entrar com Streamlabs ID",
	noAccountMessage: "Não encontramos uma conta associada a este método de entrada. Tente um método de entrada diferente ou <signup>Inscreva-se</signup> caso não o tenha feito.",
	accountExistsMessage: "Seu endereço de e-mail da Twitch já está associado ao Streamlabs. Tente entrar com seu e-mail e senha Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mail",
	codePlaceholder: "Código de e-mail de 6-8 dígitos",
	tfaCodePlaceholder: "Código de autenticação de 2 etapas",
	newPasswordPlaceholder: "Nova senha",
	tfaError: "O código de redefinição deve ter entre 6 e 10 caracteres",
	next: "Recebeu o código?",
	back: "Voltar a esqueceu sua senha",
	buttonText: "Mudar senha",
	successText: "Senha redefinida",
	create: {
		back: "Voltar ao início",
		buttonText: "Definir senha",
		successText: "Senha definida com sucesso"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Senha atual",
	newPasswordPlaceholder: "Nova senha",
	newPasswordConfirmationPlaceholder: "Confirmar nova senha",
	buttonText: "Mudar senha",
	successText: "Senha atualizada",
	newPasswordConfirmationError: "Novas senhas não compatíveis",
	back: "Voltar ao painel"
};
var changePasswordCard = {
	title: "Mudar sua senha",
	lead: "Insira sua senha atual e a nova senha abaixo.",
	successText: "Senha atualizada"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Código autorização 6 dígitos/código backup 8 dígitos",
	successText: "Autenticação de 2 etapas removida com sucesso",
	removeBtn: "Confirmar e Remover"
};
var removeTfaCard = {
	title: "Remover Autenticação de dois fatores",
	lead: "Insira o código de confirmação de autenticação de 2 etapas a seguir para removê-la de sua conta.",
	successText: "Autenticação de 2 etapas removida com sucesso",
	back: "Voltar ao painel"
};
var verifyEmailForm = {
	codePlaceholder: "Código de 8 dígitos do e-mail",
	tfaCodePlaceholder: "Código de autenticação de 2 etapas",
	emailPlaceholder: "Endereço de e-mail",
	buttonText: "Verificar e-mail",
	successText: "E-mail verificado com sucesso",
	requestBtn: "Solicitar novo código",
	requestingBtn: "Solicitando...",
	requestSuccess: "Um código foi enviado ao seu e-mail",
	requestAgain: "Solicitar novamente em {seconds}s",
	tfaError: "O código de redefinição deve ter entre 6 e 10 caracteres",
	back: "Voltar"
};
var signupCard = {
	title: "Inscrever-se",
	lead: "Criar uma conta <id>Streamlabs ID</id> para usar <company>{company}</company>",
	successText: "Sucesso! Redirecionando..."
};
var signupSourcesCard = {
	title: "Inscrever-se",
	lead: "Criar uma conta <id>Streamlabs ID</id> para usar <company>{company}</company>",
	withSlId: "Criar uma Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Escolha uma conta",
		lead: "para ir até <b>{company}</b>",
		authorize: "Autorizar",
		authorizeSuccess: "Sucesso!",
		cancel: "Cancelar",
		disclaimer: {
			streamlabs: "Continuar compartilhando a ID do Streamlabs (nome, endereço de e-mail, preferência de idioma e foto do perfil) com <b>{company}</b>. Ao autorizar uma conta com <b>{company}</b>, você concorda com a <privacy>política de privacidade</privacy> e os <terms>termos de serviço</terms> da <b>{company}</b>.",
			"default": "Para prosseguir, Streamlabs compartilhará seu nome, endereço de e-mail, idioma de preferência e imagem de perfil com <b>{company}</b>. Ao autorizar uma conta com <b>{company}</b>, você concorda com a <privacy>política de privacidade</privacy> e os <terms>termos de serviço</terms> da <b>{company}</b>."
		},
		emailRequired: "Requer verificação de e-mail para prosseguir",
		tfaRequired: "Requer autenticação de 2 etapas para prosseguir"
	},
	login: {
		title: "Entrar em {company}",
		lead: "Você deve entrar para conectar às contas",
		loginBtn: "Ir para Entrar"
	},
	error: {
		title: "Entrar em {company}",
		lead: "Não foi possível autorizar seu pedido neste momento.",
		verifyEmail: "Verificar e-mail",
		verify2fa: "Verificar 2FA"
	},
	"switch": {
		btn: "Usar outra conta"
	}
};
var appsDropdown = {
	label: "Produtos e aplicativos Streamlabs",
	viewMore: "Expandir",
	viewLess: "Recolher"
};
var platformButtons = {
	loginWithPlatform: "Entrar com uma plataforma",
	signUpWithPlatform: "Inscreva-se com uma plataforma",
	signUpLead: "Apoiamos a transmissão ao vivo para muitas outras plataformas, estas são apenas as opções de inscrição."
};
var ultraCheckoutCard = {
	title: "Aumente o nível de suas transmissões ao vivo, marca, edição e muito mais com o <b>Streamlabs Ultra</b>",
	badge: "Inclui <b>{planName}</b>",
	totalValue: "valor {price, currency}",
	price: {
		month: "{price, currency}/mês",
		year: "{price, currency}/ano"
	},
	description: {
		month: "Acesse os recursos premium do conjunto completo, incluindo <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e muito mais, disponíveis por um preço único e acessível.",
		year: "Acesse os recursos premium do conjunto completo, incluindo <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e muito mais, disponíveis por um preço único e acessível."
	},
	seeIncluded: "Saiba mais",
	buyNow: "Upgrade"
};
var ultraCheckoutBanner = {
	title: "Aumente o nível de suas transmissões ao vivo, marca, edição e muito mais com o <b>Streamlabs Ultra</b>",
	badge: "Inclui <b>{planName}</b>",
	totalValue: "valor {price, currency}",
	price: {
		month: "{price, currency}/mês",
		year: "{price, currency}/ano"
	},
	description: {
		month: "Acesse os recursos premium do conjunto completo, incluindo <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e muito mais, disponíveis por um preço único e acessível. <link />",
		year: "Acesse os recursos premium do conjunto completo, incluindo <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e muito mais, disponíveis por um preço único e acessível. <link />"
	},
	seeIncluded: "Saiba mais",
	buyNow: "Upgrade"
};
var connect = {
	waitMessage: "Mesclando dados. Não feche esta janela."
};
var verifyPasswordCard = {
	success: "Senha verificada com sucesso",
	title: "Refaça a autenticação para verificar",
	lead: "Faça login com seu e-mail e senha existentes para continuar atualizando sua ID do Streamlabs.",
	buttonText: "Próximo"
};
var emailChangeForm = {
	agreeError: "Verifique se você entende essa ação",
	buttonText: "Próximo",
	emailPlaceholder: "Novo endereço de e-mail",
	agreeText: "Entendo que, uma vez verificada, minha ID do Streamlabs será alterada em todos os produtos do Streamlabs aos quais ela estiver conectada."
};
var verifyNewEmailCard = {
	title: "Alterar sua ID Streamlabs",
	lead: "Forneça um novo e-mail para você usar como ID do Streamlabs. Enviaremos um código de verificação de 6 a 8 dígitos para esse endereço.",
	successText: "Novo e-mail disponível"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifique se você tem uma ID Streamlabs atualizado",
	lead: "Verifique em seu e-mail o código de 8 dígitos do Streamlabs e insira-o abaixo.",
	buttonText: "Confirmar",
	back: "Voltar",
	codePlaceholder: "Código de 8 dígitos do e-mail",
	successText: "Propriedade do e-mail verificada com sucesso"
};
var verifyTfaCard = {
	title: "Código de autenticação de dois fatores",
	lead: "Insira o código de verificação de seis dígitos do seu aplicativo de autenticação.",
	codePlaceholder: "Código de seis dígitos",
	buttonText: "Confirmar",
	successText: "Autenticação de dois fatores confirmada",
	back: "Voltar"
};
var ageGateForm = {
	ageLabel: "Data de nascimento",
	agePlaceholder: "DD/MM/AAAA"
};
var ageGateCard = {
	title: "Configuração completa da conta",
	lead: {
		years: "Você deve ter {years} ou mais para criar uma conta. <br />Digite sua data de nascimento para finalizar a configuração.",
		noYears: "Você deve fornecer sua data de nascimento para criar uma conta. <br />Digite-o para finalizar a configuração."
	},
	successText: "Parabéns! Configuração da conta concluída."
};
var ptBR = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { ptBR as p };
//# sourceMappingURL=pt-BR.es.js.map
